import React from 'react';
import { Redirect } from 'react-router';

import { useListingManagerRoutes } from 'modules/shared-menu/hooks/useListingManagerRoutes';

import { ImageGalleryEnhanceImages } from '../components/ImageGalleryEnhanceImages';
import { useImageGalleryContext } from '../contexts/ImageGalleryContext';
import { useUpdateListingManagerImageGallery } from '../hooks/useListingManagerImageGallery';
import { useListingManagerImageGalleryFeatureFlag } from '../hooks/useListingManagerImageGalleryFeatureFlag';

export const EditImagesPage = () => {
  const { isListingManagerImageGalleryEditEnabled } = useListingManagerImageGalleryFeatureFlag();
  const { menuEditorImageGalleryBrowseImagesPage } = useListingManagerRoutes();
  const { selectedImages, deselectImageById, deselectAll } = useImageGalleryContext();
  const { updateImageGalleryForNewImages } = useUpdateListingManagerImageGallery();

  const goBack = () => {
    updateImageGalleryForNewImages();
    deselectAll();
    history.back();
  };

  return isListingManagerImageGalleryEditEnabled ? (
    <ImageGalleryEnhanceImages
      imagesToEnhance={selectedImages}
      onDeleteImage={deselectImageById}
      onSaveResult={goBack}
      onClose={goBack}
    />
  ) : (
    <Redirect to={menuEditorImageGalleryBrowseImagesPage()} />
  );
};
